<template>
  <div ref="Einapage" class="text-justify transparent">
    <h1 class="text-center">{{ $t("portfolio.einaPage.pageLabel") }}</h1>
    <hr class="primary" />
    <a href="https://www.npmjs.com/package/einapage-vue" rel="noreferrer,noopener" target="_blank">
      <img
        :alt="$t('portfolio.einaPage.npmAltLabel')"
        src="https://nodei.co/npm/einapage-vue.png?mini=true"
        class="margin-h-sm"
      />
    </a>
    <img
      :alt="$t('portfolio.einaPage.packageAltLabel')"
      src="https://img.shields.io/badge/package-v1.4.7-orange.svg"
      class="margin-h-sm"
    />
    <a
      href="https://travis-ci.org/onca-vega/EinaPage-Vue"
      rel="noreferrer,noopener"
      target="_blank"
    >
      <img
        :alt="$t('portfolio.einaPage.buildAltLabel')"
        src="https://img.shields.io/badge/build-passing-brightgreen.svg"
        class="margin-h-sm"
      />
    </a>
    <a
      href="https://coveralls.io/github/onca-vega/EinaPage-Vue?branch=master"
      rel="noreferrer,noopener"
      target="_blank"
    >
      <img
        :alt="$t('portfolio.einaPage.coverageAltLabel')"
        src="https://coveralls.io/repos/github/onca-vega/EinaPage-Vue/badge.svg?branch=master"
        class="margin-h-sm"
      />
    </a>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Einapage"
};
</script>
